// extracted by mini-css-extract-plugin
module.exports = {"ispinner":"Spinner_ispinner__QPBpa","ispinnerBlade":"Spinner_ispinnerBlade__P1dfr","iSpinnerBlade":"Spinner_iSpinnerBlade__sAmJE"};